// extracted by mini-css-extract-plugin
export default {"empty-cart":"EmptyCart_empty-cart__vED74","empty-cart__text":"EmptyCart_empty-cart__text__3n-Y3","empty-cart__img":"EmptyCart_empty-cart__img__ysM5W"};